import { AssessAirwayActionData, AssessAirwayActions } from "../../../../components/ui/AssessAirwayUI";
import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { forceRerenderUI } from "../../../../misc/tools";
import { DaarcBaseScenario, Window508Type } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStatePart5Config, GeneralNeutralStateMainConfig } from "../GeneralNeutralStateMain";
var clickedItems: any = {};
var lastActionClicked: AssessAirwayActions = null;
export default class GeneralNeutralStatePart5 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralNeutralStatePart5Config {
		return this.scenarioConfig.part5Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Please assess airway';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions) => {
				if(context.main.onHudActionClicked(actionType)) {
					return true;
				}
				switch(actionType) {
					case HudActions.AssessAirway:
						context.showAssessAirway();
						return true;
					default:
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		if(!context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
				}
			}, context._scenario.toolbagId);
		}
	}

	public showAssessAirway() {
		clickedItems = {};
		lastActionClicked = null;
		this._showAssessAirway();
	}

	private _showAssessAirway() {
		const context = this;
		context.scenario.assessAirwayId = context._scenario.uiWrapper.displayAssessAirwayUI({
			data: context._scenario.getAssessAirwayData(),
			onActionClicked: (data: AssessAirwayActionData) => {
				if(typeof clickedItems[(data.relatedAction as number)] !== 'undefined' && clickedItems[(data.relatedAction as number)]) {
					return;
				}
				var correctIndxToClick = 0;
				context._scenario.currentTaskMessage = 'Please select the correct action';

				var optionalSelections = [
					AssessAirwayActions.RemoveDentures
				];

				if(lastActionClicked === null) {
					correctIndxToClick = 0;
				} else {
					correctIndxToClick = (lastActionClicked as number) + 1; 

					//skip optional selections
					if(optionalSelections.indexOf(correctIndxToClick as AssessAirwayActions) !== -1) {
						correctIndxToClick = (correctIndxToClick as number) + 1; 
					}
				}

				if((data.relatedAction as number) !== correctIndxToClick && optionalSelections.indexOf(data.relatedAction as AssessAirwayActions) === -1) {
					// context.scenario.uiWrapper.destroyAllUIInstances();
					// forceRerenderUI(constants.uiNames.AssessAirwayUI);
					context._scenario.displayMessage(context._scenario.currentTaskMessage, () => {
						context._showAssessAirway();
					});
					return false;
				} else {
					if(data.relatedAction === AssessAirwayActions.Done) {
						context.scenario.uiWrapper.destroyAllUIInstances();
						
						context.scenario.updateMain508Window(Window508Type.Main);
						context.scenario.update508Window(Window508Type.Main);
						forceRerenderUI(constants.uiNames.AssessAirwayUI);
						if(context.config.onAssessmentFinied) {
							context.config.onAssessmentFinied();
						}
						// context.scenario.debriefLog('Performed a complete airway assessment');
						context.main.testScenarioStartReached = true;
						context.main.loopVideo(context, context.main.config.part4Config.waitForAdjustBedHeightVideoChapter());

						context.onDone();
					} else {
						clickedItems[(data.relatedAction as number)] = true;

						if(!data.noPoints) {
							context._scenario.addScore(context._scenario.assessPatientSingleItemPoints);
						}
						// context.scenario.uiWrapper.destroyAllUIInstances();
						// forceRerenderUI(constants.uiNames.AssessAirwayUI);
						lastActionClicked = data.relatedAction;

						if(optionalSelections.indexOf(data.relatedAction as AssessAirwayActions) !== -1) {
							context._showAssessAirway();
							context.playCorrectVideo(data.relatedAction);
						} else {
							context._showAssessAirway();
							context.playCorrectVideo(data.relatedAction);
						}
					}

					return true;
				}
			}
		}, context.scenario.assessAirwayId);
	}
	public playCorrectVideo(action: AssessAirwayActions) {
		const context = this;
		switch(action) {
			case AssessAirwayActions.LiftChinToCeiling:
				context.main.loopVideo(context, context.config.liftChinVideoChapter());
				break;
			case AssessAirwayActions.PutChinToChest:
				context.main.loopVideo(context, context.config.chinToChestVideoChapter());
				break;
			case AssessAirwayActions.ExamineNeck:
				context.main.loopVideo(context, context.config.examineNeckVideoChapter());
				break;
			case AssessAirwayActions.StickOutTongue:
				context.main.loopVideo(context, context.config.stickOutTongueVideoChapter());
				break;
			case AssessAirwayActions.ShowTeeth:
				context.main.loopVideo(context, context.config.realTeethVideoChapter());
				break;
			default:
				break;
		}
	}
}